import React, { useState } from 'react';
import type { SourceRef } from '@/features/super-ai/types';

interface Props {
  sources: SourceRef[];
  className?: string;
  onOpenFile?: (fileId: string, anchor?: string) => void;
}

const statusColor: Record<string, string> = {
  Актуально: '#34d399',
  'Требует проверки': '#fbbf24',
  Проверить: '#fbbf24',
};

export const AiInlineSourcesBlock: React.FC<Props> = ({
  sources,
  className = '',
  onOpenFile,
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!sources.length) return null;

  return (
    <div className={className} data-testid="ai-inline-sources">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: '#64748b',
          fontSize: '0.78rem',
          cursor: 'pointer',
        }}
      >
        Источники {expanded ? '▴' : '▾'} ({sources.length})
      </button>
      {expanded ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.45rem', marginTop: '0.45rem' }}>
          {sources.map((ref, i) => {
            const fileId = (ref as SourceRef & { file_id?: string }).file_id;
            const anchor = (ref as SourceRef & { citation_anchor?: string }).citation_anchor;
            const excerpt = (ref as SourceRef & { excerpt_text?: string }).excerpt_text;
            const versionNo = (ref as SourceRef & { version_no?: string }).version_no;

            return (
              <div
                key={`${ref.title}-${i}`}
                style={{
                  padding: '0.55rem 0.65rem',
                  borderRadius: 8,
                  background: 'rgba(15, 23, 42, 0.55)',
                  border: '1px solid rgba(148, 163, 184, 0.18)',
                  fontSize: '0.78rem',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.5rem' }}>
                  <strong style={{ color: '#e2e8f0' }}>{ref.title}</strong>
                  <span style={{ color: statusColor[ref.status] ?? '#94a3b8', whiteSpace: 'nowrap' }}>
                    {ref.status}
                  </span>
                </div>
                {versionNo ? (
                  <div style={{ color: '#38bdf8', marginTop: 2 }}>Версия: {versionNo}</div>
                ) : null}
                {anchor ? (
                  <div style={{ color: '#94a3b8', marginTop: 2 }}>Фрагмент: {anchor}</div>
                ) : null}
                {excerpt ? (
                  <div style={{ color: '#64748b', marginTop: 4, lineHeight: 1.35 }}>{excerpt}</div>
                ) : null}
                {fileId && onOpenFile ? (
                  <button
                    type="button"
                    className="btn-open-preview"
                    style={{ marginTop: 6, padding: '0.2rem 0.5rem', fontSize: '0.72rem' }}
                    onClick={() => onOpenFile(fileId, anchor)}
                  >
                    Открыть документ
                  </button>
                ) : null}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};
